import * as React from "react";
import { ReactElement } from "react";

import { Button, Checkbox, Grid, Icon } from "semantic-ui-react";

import { TaskModel } from "@teamprevent/common/task/taskActions/models";

import { AppointmentTaskDetails } from "../../appointmentMerging/models";

import { BookAppointmentTaskListModel } from "../models";
import { isImmunisationTask } from "../../task/model";

export interface AllTaskTypesListProps {
    selectedBookTask: BookAppointmentTaskListModel;
    bookTasks: AppointmentTaskDetails[];
    selectTask: (taskModel: TaskModel) => void;
}

const AllBookAppointmentTaskTypesList: React.FC<AllTaskTypesListProps> = (props) => {

    const taskCheckBox = (bookTask: AppointmentTaskDetails): ReactElement  => {
        if (bookTask.task.id === props.selectedBookTask.id)
        {
            return <Checkbox key={bookTask.task.id} defaultChecked disabled />;
        }

        return props.selectedBookTask.locationType === bookTask.locationType ?
            (<Checkbox key={bookTask.task.id} onChange={() => {props.selectTask(bookTask.task);}} />) : (<Icon key={bookTask.task.id} name='close' />);
    };

    const getImmunisationTypes = (taskModel: TaskModel): string => {
        if (isImmunisationTask(taskModel)) {
            const immsTypes = taskModel.immunisationTypeTasks.map(t => t.name);
            return "- " + immsTypes.join(",");
        }

        return "";
    };

    const taskRow = (bookTask: AppointmentTaskDetails): ReactElement => {
        return (
            <Grid.Row>
                <Grid.Column width={2}>
                    {
                        taskCheckBox(bookTask)
                    }
                </Grid.Column>
                <Grid.Column width={6}>
                    Task Type
                    <h3>
                        {bookTask.task.description} - {bookTask.locationType}  {getImmunisationTypes(bookTask.task)}
                    </h3>
                </Grid.Column>
                <Grid.Column width={4}>
                    Employee Reference Number
                    <p>{bookTask.personalReferenceNumber}</p>
                </Grid.Column>
                <Grid.Column width={2}>
                    Due Date
                    <p>{bookTask.task.dueDate.format("L")}</p>
                </Grid.Column>
                <Grid.Column width={2}>
                    <a
                        href={`/customers/${bookTask.task.customer.id}/employeeRecords/${bookTask.task.employeeRecord.id}`
                            + `/ohCases/${bookTask.task.caseId}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Button content="View Case" />
                    </a>
                </Grid.Column>
            </Grid.Row>
        );
    };

    if (!props.selectedBookTask)
    {
        return null;
    }

    return (
        <>
            {props.bookTasks.filter(b => b.task.id === props.selectedBookTask.id).sort((a, b) => (a.task.dueDate > b.task.dueDate) ? 1 : -1)
                .map((bookTask) => taskRow(bookTask))}
            {props.bookTasks.filter(b => b.task.id !== props.selectedBookTask.id).sort((a, b) => (a.task.dueDate > b.task.dueDate) ? 1 : -1)
                .map((bookTask) => taskRow(bookTask))}
        </>
    );
};

export {
    AllBookAppointmentTaskTypesList
};
